<template>
        <div class="flex flex-col rounded-2xl p-4 bg-white border border-gray-500 min-w-[200px] max-w-[300px] w-full">
            <div>
                <h1 class="text-primary font-bold text-center">Filtros</h1>
                <div class="flex flex-col gap-y-4">
                    <ExpandableRadio :options="computedStages" placeholder="Selecione um nível" title="Nível" @updateValue="formFilter.stage = $event.id"/>
                    <SearchableExpandableCheckbox
                        :options="subregions"
                        :enable="formFilter.subregions !== true"
                        title="Sub-Regionais"
                        placeholder="Selecione uma ou mais subregionais"
                        class="max-w-[19rem] z-10"
                        @updateValue="formFilter.subregions = $event"
                        :initialValue="[]"
                    />
                    <div class="flex flex-col items-center">
                        <div>
                            <Button
                                @click.prevent="sendSpecificFilter"
                                class="bg-primary !text-white p-4">
                                Aplicar Filtros
                            </Button>
                        </div>
                        <div>
                            <button
                                @click.prevent="clearFilter"
                                class="text-primary text-xs hover:underline"
                            >
                                Limpar Filtros
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Button from "@/Components/Button.vue";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import SearchableExpandableCheckbox from "@/Components/SearchableExpandableCheckbox.vue";

export default {
    props: {
        subregions: [],
    },  
    components: {
        Head,
        Button,
        ExpandableRadio,
        SearchableExpandableCheckbox,
    },

    emits: ["updateFilter", "clearFilter"],

    data() {
        return {
            formFilter: {
                stage: 1,
                subregions: [],
            },
        };
    },

    computed: {
        computedStages() {
            return [
                {id: 1, name: 1},
                {id: 2, name: 2},
                {id: 3, name: 3},
                {id: 4, name: 4},
            ]
        }
    },
    methods: {
        sendSpecificFilter() {

            this.$emit("updateFilter", {
                stage: this.formFilter.stage,
                subregions: this.formFilter.subregions.map(el => el.id),
            });
        },
        clearFilter() {
            window.location.reload();
        }
    },
};
</script>
